import { api } from '../../../shared/api';

export interface RequestPasswordResetRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
  confirmPassword: string;
}

export interface GenerateVerifyEmailRequest {
  email: string;
}

export interface VerifyEmailRequest {
  token: string;
}

export const emailApi = {
  requestPasswordReset: async (data: RequestPasswordResetRequest) => {
    return api.post<{ success: boolean; message: string }>('/auth/request-password-reset', data);
  },

  resetPassword: async (data: ResetPasswordRequest) => {
    return api.post<{ success: boolean; message: string }>('/auth/reset-password', data);
  },

  generateVerifyEmail: async (data: GenerateVerifyEmailRequest) => {
    return api.post<{ success: boolean; message: string }>('/auth/generate-verify-email', data);
  },

  verifyEmail: async (data: VerifyEmailRequest) => {
    return api.post<{ success: boolean; message: string }>('/auth/verify-email', data);
  },
};
